import React from 'react';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import camelcaseKeys from 'camelcase-keys';
import { REASONS_TO_SHOP_TITLE } from 'src/constants/widgets';
import { SectionSkeleton } from 'src/elements/Skeletons/Skeletons';

import classes from './ReasonsToShopWithUs.scss';

const reasonsToShopWidget = gql`
    query {
        reasonsToShopWidget {
            title
            widget_parameters {
                title
                description
                image
                link
            }
        }
    }
`;

export const ReasonsToShopWithUs = () => {
    const { loading, data } = useQuery(reasonsToShopWidget, { ssr: false });

    if (loading || !data) return <SectionSkeleton height="220px" />;

    const camelizeReasonToShop = camelcaseKeys(data?.reasonsToShopWidget, { deep: true });

    const reasonsToShopData = camelizeReasonToShop.filter((el) => !el.title.includes(REASONS_TO_SHOP_TITLE));

    const reasonsTitle = camelizeReasonToShop.find((el) => el.title.includes(REASONS_TO_SHOP_TITLE));

    return (
        <div className={classes.reasonsToShopWithUs}>
            <div className={classes.header}>
                <h2 className={classes.title}>{reasonsTitle?.widgetParameters?.title}</h2>
                <p>{reasonsTitle?.widgetParameters?.description}</p>
                <a href={reasonsTitle?.widgetParameters?.link}>
                    <span>Read More</span>
                    <img src="../../../static/icons/v-right_orange.svg" alt="" />
                </a>
            </div>

            <div className={classes.elements}>
                {reasonsToShopData.map((element, key) => (
                    <div className={classes.element} key={key}>
                        <a href={element.widgetParameters.link}>
                            <img src={element.widgetParameters.image} alt={`image ${key}`} />
                            <h3>{element.widgetParameters.title}</h3>
                            <p className={classes.elementDescription}>{element.widgetParameters.description}</p>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};
